/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	__webpack_require__.p = typeof window !== 'undefined' && window.__STATICS_BASE_URL__ || __webpack_require__.p;
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* global window, global */
var G = global || window;

var _require = __webpack_require__(1),
    domains = _require.domains,
    languages = _require.languages;

var locationWithoutLanguagePrefix = function locationWithoutLanguagePrefix(location) {
  return location.protocol === 'http:' || location.protocol === 'https:' ? location.protocol + '//' + domains.wix + location.pathname + location.search : '';
};

var setLanguageUrl = function setLanguageUrl(language) {
  var redirectTo = locationWithoutLanguagePrefix(G.location);
  return 'https://' + domains.wixUsers + '/wix-users/auth/setLanguage?language=' + language + (redirectTo ? '&redirectTo=' + redirectTo : '');
};

var loginUrl = function loginUrl() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      postLogin = _ref.postLogin,
      postSignUp = _ref.postSignUp;

  var getParams = {
    loginDialogContext: 'login',
    referralInfo: 'HEADER',
    postLogin: postLogin,
    postSignUp: postSignUp
  };
  var getParamsString = Object.keys(getParams).filter(function (param) {
    return getParams[param];
  }).map(function (param) {
    return [param, encodeURIComponent(getParams[param])].join('=');
  }).join('&');
  return 'https://' + domains.wix + '/signin?' + getParamsString;
};

var languagesMenu = function languagesMenu() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return list.map(function (language) {
    return {
      text: languages[language],
      href: setLanguageUrl(language)
    };
  });
};

var obtainLanguage = function obtainLanguage() {
  var subDomain = G.location.host.split('.')[0];
  if (subDomain !== 'www' && subDomain.length === 2) {
    return subDomain;
  }
  var lang = document.cookie.indexOf('wixLanguage=') >= 0 ? document.cookie.substr(document.cookie.indexOf('wixLanguage=') + 12, 2) : 'en';
  return lang;
};

var getValueFromObjectByPrefix = function getValueFromObjectByPrefix(object) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var objectClosure = Object.assign({}, object);
  return function (key) {
    return objectClosure['' + prefix + key] || key;
  };
};

var linkObjectFromMap = function linkObjectFromMap(value, map) {
  var forLanguage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';

  var get = getValueFromObjectByPrefix(map);

  var _value$split$map = value.split(' | ').map(function (chunk) {
    return (chunk || '').trim();
  }),
      _value$split$map2 = _slicedToArray(_value$split$map, 6),
      text = _value$split$map2[0],
      href = _value$split$map2[1],
      target = _value$split$map2[2],
      rel = _value$split$map2[3],
      title = _value$split$map2[4],
      important = _value$split$map2[5];

  if (href && href.indexOf('/') === 0 && href.indexOf('//') !== 0) {
    href = '//' + (forLanguage === 'en' ? domains.wix : forLanguage + '.' + domains.wixNaked) + href;
  }
  return {
    text: get(text),
    href: href,
    target: target,
    rel: rel,
    subs: [],
    title: get(title) || href || text,
    important: !!important
  };
};

var menuFromMap = function menuFromMap(map, prefix, translations) {
  var forLanguage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'en';
  var modifiers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  // eslint-disable-line
  var menu = [];
  var index1 = void 0,
      index2 = void 0;
  index1 = 1;
  var _loop = function _loop() {
    var linkObject = linkObjectFromMap(map[prefix + '.' + index1], translations, forLanguage);
    index2 = 1;while (map[prefix + '.' + index1 + '.' + index2]) {
      linkObject.subs.push(linkObjectFromMap(map[prefix + '.' + index1 + '.' + index2], translations, forLanguage));
      index2++;
    }
    modifiers.forEach(function (modifier) {
      if (linkObject === null) {
        return;
      }
      linkObject = modifier(linkObject, forLanguage);
    });
    if (linkObject !== null) {
      menu.push(linkObject);
    }
    index1++;
  };

  while (map[prefix + '.' + index1]) {
    _loop();
  }
  return menu;
};

var createNodeInBody = function createNodeInBody() {
  var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
  var insertBefore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var classNames = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  var node = document.createElement(tagName);
  if (id) {
    node.setAttribute('id', id);
  }
  if (classNames && classNames.length) {
    node.setAttribute('class', classNames.join(' '));
  }
  document.body.insertBefore(node, insertBefore);
  return node;
};

var getRootNodes = function getRootNodes(headerSelector, footerSelector) {
  var nodes = {
    header: document.querySelector(headerSelector),
    footer: document.querySelector(footerSelector)
  };
  if (!nodes.header) {
    nodes.header = createNodeInBody('nav', document.body.firstChild);
  }
  if (!nodes.footer) {
    nodes.footer = createNodeInBody('footer', null);
  }
  return nodes;
};

var sanitizeRootNodes = function sanitizeRootNodes() {
  var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var defaults = {
    header: {
      selector: '#wix-menu',
      tag: 'nav',
      place: document.body.firstChild
    },
    footer: {
      selector: '#wix-footer',
      tag: 'footer',
      place: null
    }
  };
  ['header', 'footer'].forEach(function (part) {
    if (!(nodes[part] instanceof HTMLElement)) {
      var _defaults$part = defaults[part],
          selector = _defaults$part.selector,
          tag = _defaults$part.tag,
          place = _defaults$part.place;

      nodes[part] = document.querySelector(selector) || createNodeInBody(tag, place);
    }
  });
};

var mapObject = function mapObject(object, mapper) {
  var mappedObject = {};
  Object.keys(object).forEach(function (key) {
    return mappedObject[key] = mapper(object[key], key);
  });
  return mappedObject;
};

var innerHTML = function innerHTML(node, html, className) {
  var lang = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  node.removeAttribute('id');
  if (className) {
    node.setAttribute('class', className);
  }
  if (lang) {
    node.setAttribute('lang', lang);
  }
  node.innerHTML = html || '';
};

var arrayWithoutDublicates = function arrayWithoutDublicates(origin) {
  return origin.filter(function (item, position) {
    return origin.indexOf(item) === position;
  });
};

var getClassesFromString = function getClassesFromString(string) {
  return string ? arrayWithoutDublicates(string.split(' ')) : [];
};

var toggleClass = function toggleClass(node, string) {
  var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var classNames = getClassesFromString(node.className);
  var givenClassNames = getClassesFromString(string);
  givenClassNames.forEach(function (className) {
    var index = classNames.indexOf(className);
    if ((force === true || force === null) && index < 0) {
      classNames.push(className);
    } else if ((force === false || force === null) && index >= 0) {
      classNames.splice(index, 1);
    }
  });
  node.className = classNames.join(' ');
};

var truncate = function truncate(string, length) {
  return string.length <= length ? string : string.slice(0, length) + '…';
};

var toCamelCase = function toCamelCase(str) {
  return str.toLowerCase().replace(/[-_]+/g, ' ').replace(/[^\w\s]/g, '').replace(/ (.)/g, function (match) {
    return match.toUpperCase();
  }).replace(/ /g, '');
};

var wrapLinkWithBiEvent = function wrapLinkWithBiEvent(logger, link, evid, extendParams) {
  var listener = function listener(event) {
    event.preventDefault();
    var params = { evid: evid };
    if (extendParams) {
      Object.assign(params, extendParams(link));
    }
    logger.log(params).then(function () {
      return window.location.assign(link.href);
    });
  };
  link.addEventListener('click', listener);
  link.addEventListener('tap', listener);
};

var parseURI = function parseURI(string) {
  var link = document.createElement('a');
  link.href = string;
  return link;
};

var enlist = function enlist() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.reduce(function (result, arg) {
    return result.concat(arg);
  }, []);
};

var ensure = function ensure(value) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return value === undefined ? null : value instanceof Function ? value.apply(null, args) : value;
};

var intersection = function intersection() {
  for (var _len2 = arguments.length, arrays = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    arrays[_key2] = arguments[_key2];
  }

  return arrays.length === 0 ? [] : arrays.length === 1 ? arrayWithoutDublicates(arrays[0]) : arrays.length === 2 ? arrayWithoutDublicates(arrays[0]).filter(function (element) {
    return arrays[1].indexOf(element) >= 0;
  }) : arrays.slice(1).reduce(function (result, array) {
    return arrayWithoutDublicates(result).filter(function (element) {
      return array.indexOf(element) >= 0;
    });
  }, arrays[0]);
};

var throttle = function throttle(fn) {
  var threshhold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  var last = void 0,
      deferTimer = void 0;
  return function () {
    var now = Date.now();
    var args = arguments;
    if (last && now < last + threshhold) {
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
};

var clone = function clone(value) {
  return value === null ? null : (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'symbol' ? Symbol('cloned') : (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? JSON.parse(JSON.stringify(value)) : typeof value === 'function' ? value.bind({}) : value;
};

var capitalize = function capitalize(value) {
  return value.charAt(0).toUpperCase() + value.substr(1);
};

var warnAndReturn = function warnAndReturn(message, returnValue) {
  var printPromiseErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function () {
    var _console;

    for (var _len3 = arguments.length, errors = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      errors[_key3] = arguments[_key3];
    }

    var toPrint = printPromiseErrors ? [message].concat(errors) : [message];
    (_console = console).warn.apply(_console, _toConsumableArray(toPrint));
    return returnValue;
  };
};

var warnAndThen = function warnAndThen() {
  for (var _len4 = arguments.length, warns = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    warns[_key4] = arguments[_key4];
  }

  return new Promise(function () {
    var _console2;

    return (_console2 = console).warn.apply(_console2, warns);
  });
};

module.exports = {
  setLanguageUrl: setLanguageUrl,
  loginUrl: loginUrl,
  languagesMenu: languagesMenu,
  obtainLanguage: obtainLanguage,
  getValueFromObjectByPrefix: getValueFromObjectByPrefix,
  menuFromMap: menuFromMap,
  getRootNodes: getRootNodes,
  sanitizeRootNodes: sanitizeRootNodes,
  mapObject: mapObject,
  innerHTML: innerHTML,
  toggleClass: toggleClass,
  truncate: truncate,
  toCamelCase: toCamelCase,
  wrapLinkWithBiEvent: wrapLinkWithBiEvent,
  parseURI: parseURI,
  enlist: enlist,
  ensure: ensure,
  arrayWithoutDublicates: arrayWithoutDublicates,
  intersection: intersection,
  throttle: throttle,
  clone: clone,
  capitalize: capitalize,
  warnAndReturn: warnAndReturn,
  warnAndThen: warnAndThen
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = {"languages":{"en":"English","de":"Deutsch","es":"Español","fr":"Français","it":"Italiano","nl":"Nederlands","no":"Norsk","pl":"Polski","pt":"Português","ru":"Русский","sv":"Svenska","ja":"日本語","ko":"한국어","tr":"Türkçe","da":"Dansk","hi":"हिन्दी","cs":"Češti"},"domains":{"wix":"www.wix.com","wixNaked":"wix.com","wixUsers":"users.wix.com"},"linkModifiers":{"blog":{"hideForLanguages":["ru","ko","hi"],"showEnglishForLanguages":["de","it","tr","nl","pl","no","da","cs","sv"]},"stories":{"hideForLanguages":["fr","pt","ru","es","de","ja","ko","tr","nl","hi"],"showEnglishForLanguages":["it","pl","no","da","sv","cs"]}},"socialNetworks":{"mobile":["facebook","twitter","googleplus","instagram","linkedin"],"desktop":["facebook","twitter","googleplus","youtube","pinterest","instagram","linkedin"]},"scrollDropdownWhenItemsAmountIsBiggerThen":12}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _require = __webpack_require__(1),
    linkModifiers = _require.linkModifiers;

var _require2 = __webpack_require__(0),
    enlist = _require2.enlist,
    ensure = _require2.ensure;

function createLinkModifier(slug, doNotShowFor, showEnglishFor) {
  return function (item, language) {
    if (!item.href || item.href.substr(item.href.indexOf(slug)) !== slug) {
      return item;
    }
    if (doNotShowFor.indexOf(language) >= 0) {
      return null;
    }
    var modifiedItem = Object.assign({}, item);
    if (showEnglishFor.indexOf(language) >= 0) {
      modifiedItem.href = modifiedItem.href.replace(language + '.', 'www.');
    }
    return modifiedItem;
  };
}

function classes() {
  for (var _len = arguments.length, classNames = Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  classNames = classNames.filter(function (className) {
    return className;
  });
  return classNames.length ? 'class="' + classNames.join(' ') + '"' : '';
}

function content(item, classNames) {
  var DEFAULT_TAG = 'span';

  if (item.href) {
    item.tag = 'a';
    item.contentAttrs = item.contentAttrs || {};
    item.contentAttrs.href = item.href;
  }

  item.tag = item.tag || DEFAULT_TAG;

  var attributes = Object.keys(item.contentAttrs || {}).map(function (attribute) {
    return attribute + '="' + item.contentAttrs[attribute] + '"';
  }).join(' ');
  return '\n    <' + item.tag + ' ' + attributes + ' ' + classes.apply(undefined, _toConsumableArray(enlist(classNames.itemContent, item.classes))) + '>\n      ' + item.text + '\n      ' + (ensure(item.extraContent) || '') + '\n    </' + item.tag + '>\n  ';
}

function link(item, classNames, classNamesForSubs) {
  var attributes = Object.keys(item.attrs || {}).map(function (attribute) {
    return attribute + '="' + item.attrs[attribute] + '"';
  }).join(' ');
  var hasSubs = item.subs && item.subs.length;
  return '\n    <li ' + attributes + ' ' + classes.apply(undefined, _toConsumableArray(enlist(classNames.item, item.classes, hasSubs ? classNames.hasSubmenu : null))) + '>\n      ' + content(item, classNames) + '\n      ' + (hasSubs ? links(item.subs, classNamesForSubs || classNames) : '') + '\n    </li>\n  ';
}

function links() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var classNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var classNamesForSubs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var listClassNames = classNames.list instanceof Function ? classNames.list(list) : classNames.list;
  return '\n    <ul ' + classes.apply(undefined, _toConsumableArray(enlist(listClassNames))) + '>\n      ' + list.map(function (item) {
    return link(item, classNames, classNamesForSubs);
  }).join('') + '\n    </ul>\n  ';
}

module.exports = {
  links: links,
  modifyBlogLink: createLinkModifier('/blog', linkModifiers.blog.hideForLanguages, linkModifiers.blog.showEnglishForLanguages),
  modifyStoriesLink: createLinkModifier('/stories', linkModifiers.stories.hideForLanguages, linkModifiers.stories.showEnglishForLanguages)
};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"_5lrPp","link":"hZqF4","container":"mvq20","hidden":"wtTo7","allClosed":"_3cre5","divider":"_3TR-t","section-header":"_1y4Aj","sectionHeader":"_1y4Aj","menu-item":"_3AyXe","menuItem":"_3AyXe","important":"_2mko6","controls":"_1I1I5","menuOpen":"ETuA7","languagesOpen":"zJQfv","control-left":"_1eaBf","controlLeft":"_1eaBf","control-right":"_24GFT","controlRight":"_24GFT","visible-when-menu-closed":"_1sdx6","visibleWhenMenuClosed":"_1sdx6","visible-when-menu-open":"_3i-oh","visibleWhenMenuOpen":"_3i-oh","visible-when-languages-open":"_3MrVp","visibleWhenLanguagesOpen":"_3MrVp","logo":"_2AFq3","logo-img":"_1n7un","logoImg":"_1n7un","sections":"_20zSa","section":"SohNG","level-2":"_2nW5r","level2":"_2nW5r","headline":"DT21S","menu":"_1Px_W","menu-content":"n9P7D","menuContent":"n9P7D","active":"_18aSe","icon-to-right":"_1DtGg","iconToRight":"_1DtGg","icon-user":"_16ss0","iconUser":"_16ss0","icon-globe":"_18fKk","iconGlobe":"_18fKk","icon-logout":"_1hvHT","iconLogout":"_1hvHT","icon-arrow-right":"_3Vx69","iconArrowRight":"_3Vx69","profile-image":"_3OLkE","profileImage":"_3OLkE","profile-row":"_27C6A","profileRow":"_27C6A","marketing-header-and-footer-fixed-body":"_1yMPp","marketingHeaderAndFooterFixedBody":"_1yMPp","editor":"Ic7n-","templates":"_7WNBq"};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"NqbFo","link":"_3HzOh","container":"_1gWoZ","hidden":"_3r-MJ","icon-inline-globe":"GmGta","iconInlineGlobe":"GmGta","icon-inline-arrow-down":"_3XDv8","iconInlineArrowDown":"_3XDv8","icon-globe":"_23LQr","iconGlobe":"_23LQr","dropdown-item":"_1qX1E","dropdownItem":"_1qX1E","navigation-item":"_3e_3e","navigationItem":"_3e_3e","language-picker":"_2qUo6","languagePicker":"_2qUo6","user":"_2PFES","dropdown":"_2Md0F","dropdown-item-content":"_3nSGd","dropdownItemContent":"_3nSGd","limit-height":"_3LdNg","limitHeight":"_3LdNg","music":"_3dvFr","homepage":"_17UWs","verticals":"_3k031","logo":"Pm8VS","logo-img":"_1_iRe","logoImg":"_1_iRe","navigation":"_204AN","active":"_2yr8f","navigation-item-content":"_3krPm","navigationItemContent":"_3krPm","signin-button":"_2FyNn","signinButton":"_2FyNn","user-pic":"MzEqL","userPic":"MzEqL","user-name":"_252ax","userName":"_252ax","editor":"_1zhVE"};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHost = setHost;
exports.getHost = getHost;
exports.isWebWorker = isWebWorker;
exports.provideBrowsingContext = provideBrowsingContext;
var host = 'frog.wix.com';

function setHost(_host) {
  host = _host;
}

function getHost() {
  return host;
}

function isWebWorker() {
  /* global WorkerGlobalScope */

  //At the moment, this is the most reliable way of detecting if current code is run in a worker
  //Taken from here: https://stackoverflow.com/a/18002694
  return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
}

/**
 * Provides a window object to the callback iff current window is the topmost one
 * Otherwise returns null
 */
function provideBrowsingContext(cb) {
  if (typeof window !== 'undefined' && window) {
    try {
      return window.top === window.self ? cb ? cb(window) : window : null;
    } catch (e) {
      return null;
    }
  }

  return null;
}
//# sourceMappingURL=env.js.map


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var css = __webpack_require__(3);

var _require = __webpack_require__(0),
    toggleClass = _require.toggleClass,
    wrapLinkWithBiEvent = _require.wrapLinkWithBiEvent,
    parseURI = _require.parseURI;

var _require2 = __webpack_require__(1),
    domains = _require2.domains;

var bi = __webpack_require__(13);
var radioInputName = 'marketing-header-and-footer-state-' + Math.random().toString(36).substr(2);

module.exports = {
  radioInputName: radioInputName,

  bindStateChangeListener: function bindStateChangeListener() {
    document.querySelectorAll('input[name="' + radioInputName + '"]').forEach(function (element) {
      return element.addEventListener('change', function (event) {
        var closed = event.target.id === css.allClosed;
        if (!closed) {
          bi.mobile.log({ evid: 202 });
        }
        toggleClass(document.body, css.marketingHeaderAndFooterFixedBody, !closed);
      });
    });
  },
  markCurrentMenuItem: function markCurrentMenuItem() {
    var link = document.querySelector('.' + css.section + ':first-child .' + css.menuItem + ' a[href$="' + location.pathname + '"]');
    if (link) {
      toggleClass(link, css.active, true);
    }
  },
  bindLinkClicks: function bindLinkClicks() {
    document.querySelectorAll('.' + css.section + ':first-child .' + css.menuItem + ' a').forEach(function (link) {
      return wrapLinkWithBiEvent(bi.mobile, link, 203, function (link) {
        var uri = parseURI(link.href);
        var name = uri.hostname === domains.wix ? uri.pathname === '/' ? 'wix' : uri.pathname.substr(1) : uri.hostname;
        return { name: name };
      });
    });

    var signupLink = document.querySelector('.' + css.section + ':first-child .' + css.sectionHeader + ' a[rel=login]');
    if (signupLink) {
      wrapLinkWithBiEvent(bi.mobile, signupLink, 202);
    }
  },
  preventSafariBackButtonCache: function preventSafariBackButtonCache() {
    if (navigator.platform === 'iPhone' && navigator.appVersion.indefOx('Safari') >= 0) {
      window.addEventListener('onpageshow', function (event) {
        return event.persisted ? document.querySelector('input[name="' + radioInputName + '"]').click() : undefined;
      });
    }
  }
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"MbDB2","link":"_2DxmO","container":"_3EEpt","hidden":"_1dRW9","menu":"jcZ9r","menu-content":"WNsef","menuContent":"WNsef","social":"qeP4H","social-item":"X-d_F","socialItem":"X-d_F","icon-inline-facebook":"_3fREX","iconInlineFacebook":"_3fREX","icon-inline-twitter":"_2xiRt","iconInlineTwitter":"_2xiRt","icon-inline-googleplus":"_2lVYy","iconInlineGoogleplus":"_2lVYy","icon-inline-instagram":"_35Avx","iconInlineInstagram":"_35Avx","icon-inline-linkedin":"_31TG2","iconInlineLinkedin":"_31TG2","icon-inline-youtube":"_1mcg3","iconInlineYoutube":"_1mcg3","icon-inline-pinterest":"_1BWJx","iconInlinePinterest":"_1BWJx","copyrights":"_13FsG"};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"_2zCtf","link":"qLqYO","container":"_1dLg0","hidden":"_1cQFv","content-wrapper":"_1MoKt","contentWrapper":"_1MoKt","menu-heading":"_2fmhZ","menuHeading":"_2fmhZ","menu-item":"_28jbM","menuItem":"_28jbM","menu":"_2Qjco","menu-column":"_23Jjs","menuColumn":"_23Jjs","menu-list":"TkluX","menuList":"TkluX","aside-logo":"EuwWg","asideLogo":"EuwWg","aside-paragraph":"_2aXQt","asideParagraph":"_2aXQt","aside":"_3Wrg7","social":"UBvAk","social-item":"_2Oz2K","socialItem":"_2Oz2K","icon-inline-facebook":"_2rXF7","iconInlineFacebook":"_2rXF7","icon-inline-twitter":"-e-dV","iconInlineTwitter":"-e-dV","icon-inline-googleplus":"_2QOxP","iconInlineGoogleplus":"_2QOxP","icon-inline-instagram":"_3JE0D","iconInlineInstagram":"_3JE0D","icon-inline-linkedin":"_2zVvX","iconInlineLinkedin":"_2zVvX","icon-inline-youtube":"_1MZlx","iconInlineYoutube":"_1MZlx","icon-inline-pinterest":"VhsP_","iconInlinePinterest":"VhsP_","templates":"_28TBN","editor":"_1bt1j"};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = "<svg width=\"17px\" height=\"17px\" viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <path fill=\"#43515c\" d=\"M9.8646,14.853 C10.6986,13.834 11.3396,12.478 11.6916,11 L14.4986,11 C13.6876,12.939 11.9626,14.403 9.8646,14.853 L9.8646,14.853 Z M2.5016,11 L5.3086,11 C5.6606,12.478 6.3016,13.834 7.1356,14.853 C5.0376,14.403 3.3126,12.939 2.5016,11 L2.5016,11 Z M7.1356,2.147 C6.3016,3.166 5.6606,4.521 5.3086,6 L2.5016,6 C3.3126,4.061 5.0376,2.597 7.1356,2.147 L7.1356,2.147 Z M10.6676,6 L6.3316,6 C6.7436,4.412 7.5136,2.998 8.4996,2.14 C9.4866,2.998 10.2566,4.412 10.6676,6 L10.6676,6 Z M1.9996,8.5 C1.9996,7.983 2.0676,7.482 2.1816,7 L5.1206,7 C5.0496,7.497 4.9996,7.998 4.9996,8.5 C4.9996,9.002 5.0496,9.503 5.1206,10 L2.1816,10 C2.0676,9.518 1.9996,9.017 1.9996,8.5 L1.9996,8.5 Z M6.1276,10 C6.0506,9.505 5.9996,9.003 5.9996,8.5 C5.9996,7.997 6.0506,7.495 6.1276,7 L10.8726,7 C10.9496,7.495 10.9996,7.997 10.9996,8.5 C10.9996,9.003 10.9496,9.505 10.8726,10 L6.1276,10 Z M6.3316,11 L10.6676,11 C10.2566,12.588 9.4866,14.002 8.4996,14.86 C7.5136,14.002 6.7436,12.588 6.3316,11 L6.3316,11 Z M14.9996,8.5 C14.9996,9.017 14.9326,9.518 14.8186,10 L11.8796,10 C11.9496,9.503 11.9996,9.002 11.9996,8.5 C11.9996,7.998 11.9496,7.497 11.8796,7 L14.8186,7 C14.9326,7.482 14.9996,7.983 14.9996,8.5 L14.9996,8.5 Z M14.4986,6 L11.6916,6 C11.3396,4.521 10.6986,3.166 9.8646,2.147 C11.9626,2.597 13.6876,4.061 14.4986,6 L14.4986,6 Z M8.4996,1 C4.3646,1 0.9996,4.364 0.9996,8.5 C0.9996,12.636 4.3646,16 8.4996,16 C12.6356,16 15.9996,12.636 15.9996,8.5 C15.9996,4.364 12.6356,1 8.4996,1 L8.4996,1 Z\"></path>\n</svg>";

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = "<svg width=\"12px\" height=\"6px\" viewBox=\"0 0 12 6\" xmlns=\"http://www.w3.org/2000/svg\">\n    <polygon fill=\"#1F303C\" points=\"5 5.7 0 0.7 0.7 0 5 4.4 9.3 0 10 0.7 \"></polygon>\n</svg>";

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var css = __webpack_require__(4);

var _require = __webpack_require__(0),
    toggleClass = _require.toggleClass;

module.exports = {
  markCurrentMenuItem: function markCurrentMenuItem() {
    var mainListItems = document.querySelectorAll('.' + css.navigationItem);
    for (var index = 0; index < mainListItems.length; index++) {
      if (mainListItems[index].querySelector('a[href$="' + location.pathname + '"]')) {
        toggleClass(mainListItems[index], css.active, true);
        break;
      }
    }
  }
};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mobile = exports.desktop = undefined;

var _webBiLogger = __webpack_require__(37);

var _webBiLogger2 = _interopRequireDefault(_webBiLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var desktop = exports.desktop = _webBiLogger2.default.factory({ endpoint: 'hf' }).setDefaults({ src: 19 }).logger();
var mobile = exports.mobile = _webBiLogger2.default.factory({ endpoint: 'mhp' }).setDefaults({ src: 19 }).logger();

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssertionError = function (_Error) {
  _inherits(AssertionError, _Error);

  function AssertionError(message) {
    _classCallCheck(this, AssertionError);

    var _this = _possibleConstructorReturn(this, (AssertionError.__proto__ || Object.getPrototypeOf(AssertionError)).call(this, message));

    _this.name = _this.constructor.name;
    return _this;
  }

  return AssertionError;
}(Error);

function assertDefined(target, message) {
  if (target === undefined) {
    throw new AssertionError(message);
  }
}

function assertObject(target, message) {
  if (target !== undefined && ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object' || Array.isArray(target) || target === null)) {
    throw new AssertionError(message);
  }
}

function assertOk(target, message) {
  if (!target) {
    throw new AssertionError(message);
  }
}

module.exports.defined = assertDefined;
module.exports.object = assertObject;
module.exports.ok = assertOk;
module.exports.AssertionError = AssertionError;
//# sourceMappingURL=assert.js.map

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildUrl = buildUrl;
exports.guid = guid;

var _performance = __webpack_require__(44);

var _env = __webpack_require__(5);

var DEFAULT_ENDPOINT = '';

var cacheKillerCounter = 0;

function addParam(url, key, value) {
  var separator = url.indexOf('?') === -1 ? '?' : '&';
  return '' + url + separator + encodeURIComponent(key) + '=' + encodeURIComponent(value);
}

function buildUrl(_ref, params) {
  var host = _ref.host,
      _ref$endpoint = _ref.endpoint,
      endpoint = _ref$endpoint === undefined ? DEFAULT_ENDPOINT : _ref$endpoint;

  host = host || (0, _env.getHost)();

  params._ = '' + new Date().getTime() + cacheKillerCounter++;
  params.ms = Math.round((0, _performance.now)());

  var prefix = '//' + host + '/' + endpoint;
  return Object.keys(params).reduce(function (url, key) {
    return addParam(url, key, params[key]);
  }, prefix);
}

function guid() {
  /*eslint-disable */
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
  /*eslint-enable */
}
//# sourceMappingURL=utils.js.map


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listen = listen;
exports.sendBeacon = sendBeacon;

var _env = __webpack_require__(5);

function hook(obj, fnName, hook) {
  if (!obj || !obj[fnName]) {
    return;
  }

  var original = obj[fnName];
  obj[fnName] = function () {
    hook.apply(null, arguments);
    return original.apply(obj, arguments);
  };
}

function onLoad(cb) {
  setTimeout(function () {
    return (0, _env.provideBrowsingContext)(function (window) {
      return cb(window.location.href);
    });
  });
}

function onPushState(cb) {
  (0, _env.provideBrowsingContext)(function (_ref) {
    var history = _ref.history;
    return ['pushState', 'replaceState'].forEach(function (fnName) {
      hook(history, fnName, function (_, __, url) {
        return cb(url);
      });
    });
  });
}

function onPopState(cb) {
  (0, _env.provideBrowsingContext)(function (window) {
    return window.addEventListener('popstate', function () {
      return cb(window.location.href);
    });
  });
}

function listen(cb) {
  var fromUrl = '';

  [onLoad, onPushState, onPopState].forEach(function (event) {
    return event(function (toUrl) {
      cb(fromUrl, toUrl);
      fromUrl = toUrl;
    });
  });
}

function sendBeacon(url) {
  if (typeof navigator === 'undefined' || !navigator || !navigator.sendBeacon) {
    return false;
  }

  return navigator.sendBeacon(url);
}
//# sourceMappingURL=navigator.js.map


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.obtainFromDOM = exports.defaultProfileImage = exports.sanitize = exports.getDefault = exports.useMobileVersion = exports.defaultScreenBreakpoint = undefined;

var _meta = __webpack_require__(47);

var _utils = __webpack_require__(0);

var _constants = __webpack_require__(1);

var defaultScreenBreakpoint = exports.defaultScreenBreakpoint = 750;
var specification = {
  baseUrl: {
    default: _meta.baseUrl || '',
    parser: function parser(value) {
      return String(value);
    }
  },
  supportedLanguages: {
    default: Object.keys(_constants.languages),
    parser: function parser(value) {
      return (0, _utils.arrayWithoutDublicates)((typeof value === 'string' ? value.split(' ') : Array.isArray(value) ? value : Object.keys(_constants.languages)).filter(function (language) {
        return language && language in _constants.languages;
      }));
    }
  },
  language: {
    default: (0, _utils.obtainLanguage)(),
    parser: function parser(value) {
      return value in _constants.languages ? value : 'en';
    }
  },
  forceView: {
    default: null, // can be null, 'desktop' or 'mobile'
    parser: function parser(value) {
      return ['desktop', 'mobile'].indexOf(value) >= 0 ? value : null;
    }
  },
  screenBreakpoint: {
    default: defaultScreenBreakpoint,
    parser: function parser(value) {
      return parseInt(value) >= 0 ? parseInt(value) : defaultScreenBreakpoint;
    }
  },
  postLogin: {
    default: 'https://' + _constants.domains.wix + '/my-account/sites/',
    parser: function parser(value) {
      return String(value);
    }
  },
  postSignUp: {
    default: 'https://' + _constants.domains.wix + '/new/account/',
    parser: function parser(value) {
      return String(value);
    }
  },
  hostPage: {
    default: null, // can be 'homepage', 'templates', 'editor', 'verticals', 'music' or null
    parser: function parser(value) {
      return ['homepage', 'templates', 'editor', 'verticals', 'music'].indexOf(value) >= 0 ? value : null;
    }
  }
};

var useMobileVersion = exports.useMobileVersion = function useMobileVersion(config) {
  return config.forceView ? config.forceView === 'mobile' : window.innerWidth < config.screenBreakpoint;
};

var getDefault = exports.getDefault = function getDefault() {
  return Object.assign({}, (0, _utils.mapObject)(specification, function (value) {
    return value.default;
  }));
};

var sanitize = exports.sanitize = function sanitize() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var output = (0, _utils.mapObject)(specification, function (value, key) {
    return input[key] === undefined ? (0, _utils.clone)(value.default) : value.parser(input[key]);
  });
  if (output.supportedLanguages.indexOf(output.language) < 0) {
    output.language = 'en';
  }
  return output;
};

var defaultProfileImage = exports.defaultProfileImage = function defaultProfileImage(config) {
  return config.baseUrl + 'assets/default-profile-image.svg';
};

var obtainFromDOM = exports.obtainFromDOM = function obtainFromDOM() {
  var artifact = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'marketing-header-and-footer';

  var node = document.querySelector('script[data-artifact=' + artifact + ']');
  if (!node) {
    console.warn('Cannot obtain header and footer config from DOM, fallback to default');
    return getDefault();
  }
  var config = {};
  Object.keys(node.dataset || {}).filter(function (dataAttributeName) {
    return dataAttributeName.indexOf('config') === 0;
  }).forEach(function (dataAttributeName) {
    var key = dataAttributeName.substr(6);
    key = key.charAt(0).toLowerCase() + key.slice(1);
    config[key] = node.dataset[dataAttributeName];
    config.baseUrl = node.src.substr(0, node.src.indexOf('app.bundle'));
  });
  return sanitize(config);
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    loginUrl = _require.loginUrl,
    languagesMenu = _require.languagesMenu;

var _require2 = __webpack_require__(1),
    languages = _require2.languages,
    scrollDropdownWhenItemsAmountIsBiggerThen = _require2.scrollDropdownWhenItemsAmountIsBiggerThen;

var _require3 = __webpack_require__(2),
    links = _require3.links;

var css = __webpack_require__(4);
var icons = {
  globe: __webpack_require__(9).default,
  arrowDown: __webpack_require__(10).default
};

var dropdown = function dropdown(items) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      _ref$iconClass = _ref.iconClass,
      iconClass = _ref$iconClass === undefined ? '' : _ref$iconClass,
      _ref$icon = _ref.icon,
      icon = _ref$icon === undefined ? null : _ref$icon;

  return '\n  <button type="button" class="' + css.icon + ' ' + iconClass + '" title="' + title + '">' + (icon || '') + '</button>\n  ' + links(items, {
    list: function list(items) {
      return items.length > scrollDropdownWhenItemsAmountIsBiggerThen ? [css.dropdown, css.limitHeight] : css.dropdown;
    },
    item: css.dropdownItem,
    itemContent: css.dropdownItemContent
  }) + '\n';
};

module.exports = function (_ref2) {
  var mainLinks = _ref2.mainLinks,
      userLinks = _ref2.userLinks,
      user = _ref2.user,
      t = _ref2.t,
      config = _ref2.config;
  return '\n  <a href="//wix.com/" class="' + css.logo + '" title="' + t('title_wix_logo') + '">\n    <img src="' + config.baseUrl + '/assets/wix-black.svg" class="' + css.logoImg + '" alt="Wix">\n  </a>\n  <ul class="' + css.navigation + '">\n    ' + mainLinks.map(function (item) {
    return '\n      <li class="' + css.navigationItem + '">\n        <a href="' + item.href + '" class="' + css.navigationItemContent + '">' + item.text + '</a>\n        ' + (item.subs && item.subs.length ? dropdown(item.subs, { title: '', icon: icons.arrowDown }) : '') + '\n      </li>\n    ';
  }).join('') + '\n  </ul>\n  ' + (user ? '\n    <div class="' + css.user + '">\n      <img src="' + user.profileImage + '" alt="' + user.userName + '" class="' + css.userPic + '">\n      <div class="' + css.userName + '">' + user.userName + '</div>\n      ' + dropdown(userLinks, { title: '', iconClass: css.iconInlineArrowDown, icon: icons.arrowDown }) + '\n    </div>\n  ' : '\n    <div class="' + css.languagePicker + '">\n      ' + dropdown(languagesMenu(Object.keys(languages)), { title: t('choose_language'), iconClass: css.iconInlineGlobe, icon: icons.globe }) + '\n    </div>\n    <a href="' + loginUrl(config) + '" title="' + t('title_signin') + '" class="' + css.signinButton + '">' + t('signin') + '</a>\n  ') + '\n';
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    languagesMenu = _require.languagesMenu,
    loginUrl = _require.loginUrl;

var _require2 = __webpack_require__(2),
    links = _require2.links;

var css = __webpack_require__(3);

var _require3 = __webpack_require__(6),
    radioInputName = _require3.radioInputName;

module.exports = function (_ref) {
  var mainLinks = _ref.mainLinks,
      t = _ref.t,
      config = _ref.config,
      user = _ref.user;
  return '\n  <input type="radio" name="' + radioInputName + '" class="' + css.hidden + '" id="' + css.allClosed + '" checked>\n  <input type="radio" name="' + radioInputName + '" class="' + css.hidden + '" id="' + css.menuOpen + '">\n  <input type="radio" name="' + radioInputName + '" class="' + css.hidden + '" id="' + css.languagesOpen + '">\n  <div class="' + css.controls + '">\n    <a href="//wix.com/" class="' + css.logo + ' ' + css.controlLeft + '" title="' + t('title_wix_logo') + '">\n      <img src="' + config.baseUrl + 'assets/wix.svg" class="' + css.logoImg + '" alt="Wix">\n    </a>\n    <label class="' + css.visibleWhenMenuClosed + ' ' + css.controlRight + '" for="' + css.menuOpen + '">\n      <img src="' + config.baseUrl + 'assets/menu.svg" alt="' + t('open_menu') + '">\n    </label>\n    <label class="' + css.visibleWhenMenuOpen + ' ' + css.controlRight + '" for="' + css.allClosed + '">\n      <img src="' + config.baseUrl + 'assets/close.svg" alt="' + t('close') + '">\n    </label>\n    <label class="' + css.visibleWhenLanguagesOpen + ' ' + css.controlLeft + '" for="' + css.menuOpen + '">\n      <img src="' + config.baseUrl + 'assets/back.svg" alt="' + t('back') + '">\n    </label>\n  </div>\n  <div class="' + css.sections + '">\n    <section class="' + css.section + '">\n      <h2 class="' + css.sectionHeader + ' ' + css.divider + '">\n        ' + (user ? '\n            <img class="' + css.profileImage + '" src="' + user.profileImage + '" alt="' + user.userName + '">\n            <span class="' + css.profileRow + '">' + t('hello') + ',</span>\n            <span class="' + css.profileRow + '">' + user.userName + '</span>\n          ' : '\n            <a href="' + loginUrl(config) + '" title="' + t('title_signin') + '">\n              <i class="' + css.icon + ' ' + css.iconUser + '" title="' + t('signup_form_submit') + '"></i>\n              ' + t('signup_form_submit') + '\n            </a>\n          ') + '\n      </h2>\n      ' + links(mainLinks, {
    list: css.menu,
    item: css.menuItem,
    itemContent: css.menuContent + ' ' + css.link
  }) + '\n    </section>\n    <section class="' + css.section + ' ' + css.level2 + '">\n      <h2 class="' + css.sectionHeader + ' ' + css.divider + '">\n        <span class="' + css.headline + '">' + t('choose_language') + '</span>\n      </h2>\n      ' + links(languagesMenu(config.supportedLanguages), {
    list: css.menu,
    item: css.menuItem,
    itemContent: css.menuContent
  }) + '\n    </section>\n  </div>\n';
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\">\n    <path d=\"M15.26,4.74h3.68V0H15.26C12.11,0,9.61,2.76,9.61,6.32V8.68H5.92v4.74H9.61V25h4.74V13.42h4.74V8.68H14.34V6.18C14.34,5.39,14.87,4.74,15.26,4.74Z\"/>\n</svg>";

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\">\n    <path d=\"M21.68,3.76V.39H19.93V3.76H16.56V5.51h3.37V8.88h1.75V5.51H25V3.76ZM15.93,0H8.57C4.82,0,1.7,2.76,1.7,5.76a5.31,5.31,0,0,0,5.62,5.62h.75a2.62,2.62,0,0,0-.5,1.37,2.55,2.55,0,0,0,1,1.87H7.19c-4.25,0-7.24,3-7.24,5.74S3.7,25,7.94,25c4.87,0,7.87-2.75,7.87-5.49,0-2.25-.5-3.37-2.87-5.12-.62-.5-2.12-1.5-2.12-2.25s.25-1.25,1.5-2.25A4.92,4.92,0,0,0,14.44,6a4.58,4.58,0,0,0-2.12-4.12h1.87Zm-2.5,19c0,.25.12.5.12.75,0,2.25-1.5,4-5.62,4-3,0-5.12-1.87-5.12-4.12s2.5-4.12,5.49-4.12a7.56,7.56,0,0,1,1.87.25C11.81,17,13.19,17.74,13.44,19ZM8.69,10.25c-2,0-3.87-1.87-4.25-4.5s1-4.62,3-4.5,3.75,2.25,4,4.75S10.69,10.25,8.69,10.25Z\"/>\n</svg>";

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\">\n    <path d=\"M20.28.21H4.72A4.55,4.55,0,0,0,.21,4.72V20.28a4.55,4.55,0,0,0,4.51,4.51H20.28a4.55,4.55,0,0,0,4.51-4.51V4.72A4.55,4.55,0,0,0,20.28.21Zm1.23,2.73h.55V7H18V2.94ZM12.64,7.72c3.14,0,3.82,2.59,3.82,4.23a4.22,4.22,0,0,1-3.82,3.82A4,4,0,0,1,8.81,12C8.81,10,9.36,7.72,12.64,7.72Zm9.42,12.16a2.16,2.16,0,0,1-2.19,2.19H5.26a2.16,2.16,0,0,1-2.19-2.19V9.77H7.72a5,5,0,0,0-.27,2,5.33,5.33,0,1,0,10.65,0,3.47,3.47,0,0,0-.41-2H22.2V19.88Z\"/>\n</svg>";

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\">\n    <g>\n        <rect x=\"0.26\" y=\"8.65\" width=\"4.97\" height=\"16.15\"/>\n        <path d=\"M3,.2A2.88,2.88,0,0,0-.11,3.06a3,3,0,0,0,3,3.11h0A3.07,3.07,0,0,0,6,3.06,2.77,2.77,0,0,0,3,.2Z\"/>\n        <path d=\"M18.77,7.78c-3,0-3.6,1.74-4.84,2.86v-2H9.33c.12,1.24,0,16.15,0,16.15h4.6V15.61a4.4,4.4,0,0,1,.37-1.37,2.71,2.71,0,0,1,2.61-2c2,0,3.23,1.49,3.23,3.73V24.8h5V15.36C25.11,10.26,22.38,7.78,18.77,7.78Z\"/>\n    </g>\n</svg>";

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\">\n  <path d=\"M12.5,1.7c-5.6,0-8.4,4-8.4,7.4c0,2,0.8,3.8,2.4,4.5c0.3,0.1,0.5,0,0.6-0.3 c0.1-0.2,0.2-0.7,0.2-0.9c0.1-0.3,0-0.4-0.2-0.7c-0.5-0.6-0.8-1.3-0.8-2.3c0-3,2.2-5.6,5.8-5.6c3.2,0,4.9,1.9,4.9,4.5 c0,3.4-1.5,6.3-3.7,6.3c-1.2,0-2.1-1-1.9-2.3c0.4-1.5,1-3.1,1-4.2c0-1-0.5-1.8-1.6-1.8c-1.3,0-2.3,1.3-2.3,3c0,1.1,0.4,1.9,0.4,1.9 s-1.3,5.5-1.5,6.4c-0.4,1.9-0.1,4.2,0,4.5c0,0.1,0.2,0.2,0.3,0.1c0.1-0.2,1.6-2,2.1-3.9c0.1-0.5,0.8-3.2,0.8-3.2 c0.4,0.8,1.6,1.5,2.9,1.5c3.8,0,6.3-3.5,6.3-8.1C19.9,5,17,1.7,12.5,1.7z\"/>\n</svg>";

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\">\n    <path d=\"M25,4.66a8.77,8.77,0,0,1-3,.8,6.2,6.2,0,0,0,2.27-2.84A10.44,10.44,0,0,1,21,3.86a5,5,0,0,0-3.75-1.59,5.09,5.09,0,0,0-5.11,5.11,3.5,3.5,0,0,0,.11,1.14A14.55,14.55,0,0,1,1.7,3.18,5.28,5.28,0,0,0,1,5.8,5.17,5.17,0,0,0,3.3,10.11,4.1,4.1,0,0,1,1,9.43v.11a5.35,5.35,0,0,0,4.09,5.11,5.7,5.7,0,0,1-1.36.23,2.22,2.22,0,0,1-.91-.11,5.27,5.27,0,0,0,4.77,3.64,10.24,10.24,0,0,1-6.36,2.16A4.66,4.66,0,0,1,0,20.45a14.38,14.38,0,0,0,7.84,2.27c9.43,0,14.55-7.84,14.55-14.66V7.39A11.86,11.86,0,0,0,25,4.66Z\"/>\n</svg>";

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\">\n    <path d=\"M24.75,7.15a6,6,0,0,0-.91-2.51,3,3,0,0,0-2.39-1c-3.42-.23-9.11-.23-9.11-.23h0s-5.35,0-8.77.23a4,4,0,0,0-2.39,1A6,6,0,0,0,.25,7.15S0,9.77,0,11.7v1.94c0,2.05.23,4.22.23,4.22a6,6,0,0,0,.91,2.51,3.85,3.85,0,0,0,2.62,1c1.94.23,8.54.23,8.54.23s5.7,0,9.11-.23a4,4,0,0,0,2.39-1,6,6,0,0,0,.91-2.51s.23-2.28.23-4.22V11.82C25,9.77,24.75,7.15,24.75,7.15ZM9.82,15.92V8.4l6.49,4.1Z\"/>\n</svg>";

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(2),
    links = _require.links;

var css = __webpack_require__(8);

var _require2 = __webpack_require__(1),
    domains = _require2.domains;

module.exports = function (_ref) {
  var mainLinks = _ref.mainLinks,
      socialLinks = _ref.socialLinks,
      t = _ref.t;
  return '\n  <div class="' + css.contentWrapper + '">\n    ' + links(mainLinks, {
    list: css.menu,
    item: css.menuColumn,
    itemContent: css.menuHeading
  }, {
    list: css.menuList,
    item: css.menuItem
  }) + '\n\n    <div class="' + css.aside + '">\n      <a href="//' + domains.wix + '/" class="' + css.asideLogo + '" title="' + t('title_wix_logo') + '">Wix.com</a>\n      <p class="' + css.asideParagraph + '">' + t('description') + '</p>\n      <p class="' + css.asideParagraph + '">' + t('closing_line1') + ' ' + t('closing_line2') + '</p>\n      <p class="' + css.asideParagraph + '">' + t('closing_years') + '</p>\n      ' + links(socialLinks, {
    list: css.social,
    item: css.socialItem
  }) + '\n    </div>\n  </div>\n';
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(2),
    links = _require.links;

var css = __webpack_require__(7);

module.exports = function (_ref) {
  var mainLinks = _ref.mainLinks,
      socialLinks = _ref.socialLinks,
      t = _ref.t;
  return '\n  ' + links(mainLinks, {
    list: css.menu,
    itemContent: css.menuContent
  }) + '\n\n  ' + links(socialLinks, {
    list: css.social,
    item: css.socialItem
  }) + '\n\n  <div class="' + css.copyrights + '">' + t('closing_years') + '</div>\n';
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* global W, window */


exports.default = init;

__webpack_require__(30);

var _promisePolyfill = __webpack_require__(32);

var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);

__webpack_require__(36);

var _bi = __webpack_require__(13);

var bi = _interopRequireWildcard(_bi);

var _utils = __webpack_require__(0);

var _config = __webpack_require__(17);

var _constants = __webpack_require__(1);

var _render = __webpack_require__(48);

var _render2 = _interopRequireDefault(_render);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.Promise = window.Promise || _promisePolyfill2.default;


var acceptJSONHeaders = new Headers({ Accept: 'application/json' });

var fetchI18N = function fetchI18N(config) {
  return fetch(config.baseUrl + 'assets/locale/messages/messages_' + config.language + '.json').then(function (response) {
    return response.json();
  }).catch((0, _utils.warnAndReturn)('Error getting i18n files', null));
};

var fetchUserDetails = function fetchUserDetails() {
  return fetch(window.__DEBUG__ ? '/userDetails' : '//' + _constants.domains.wix + '/_api/wix-html-login-webapp/user/getUserDetails', { headers: acceptJSONHeaders, credentials: 'include' }).then(function (response) {
    return response.json();
  }).then(function (response) {
    return response.success && response.errorCode === 0 ? response.payload : null;
  }).catch((0, _utils.warnAndReturn)('Error getting user details', null));
};

var fetchProfileImage = function fetchProfileImage(config) {
  return fetch(window.__DEBUG__ ? '/userImage' : '//' + _constants.domains.wix + '/_api/account-info-server/profileimage', { headers: acceptJSONHeaders, credentials: 'include' }).then(function (response) {
    return response.json();
  }).then(function (response) {
    return response.profileImage || (0, _config.defaultProfileImage)(config);
  }).catch((0, _utils.warnAndReturn)('Error getting profile image, set to default', (0, _config.defaultProfileImage)(config)));
};

var inited = false;

function init(config) {
  var nodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (inited) {
    return (0, _utils.warnAndThen)('Header and footer is already embedded, don\'t do it twice');
  }inited = true;

  config = (0, _config.sanitize)(config);

  var tasks = document.cookie.indexOf('wixClient') >= 0 ? [fetchI18N(config), fetchUserDetails(config), fetchProfileImage(config)] : [fetchI18N(config)];

  return _promisePolyfill2.default.all(tasks).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
        translations = _ref2[0],
        user = _ref2[1],
        profileImage = _ref2[2];

    if (!translations) {
      return (0, _utils.warnAndThen)();
    }

    if (user) {
      user.profileImage = profileImage;
    }

    (0, _utils.sanitizeRootNodes)(nodes);

    var isMobile = (0, _config.useMobileVersion)(config);

    window.addEventListener('resize', (0, _utils.throttle)(function () {
      if (isMobile !== (0, _config.useMobileVersion)(config)) {
        isMobile = (0, _config.useMobileVersion)(config);
        (0, _render2.default)(nodes, config, translations, user);
      }
    }, 200));
    (0, _render2.default)(nodes, config, translations, user);

    bi.desktop.log({ evid: 500, is_mobile: isMobile, component: 'header' }); // eslint-disable-line
  }).catch(function (e) {
    return (0, _utils.warnAndThen)('Error embedding header and footer', e);
  });
}

// export API to global W if it is defined
// useful for old grunt-based FE stack
if (W && W.Site && W.Site.Common) {
  W.Site.Common.marketingHeaderAndFooter = {
    init: init, obtainConfigFromDOM: _config.obtainFromDOM
  };
}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(31).polyfill();


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */



function assign(target, firstSource) {
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert first argument to object');
  }

  var to = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];
    if (nextSource === undefined || nextSource === null) {
      continue;
    }

    var keysArray = Object.keys(Object(nextSource));
    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex];
      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
      if (desc !== undefined && desc.enumerable) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }
  return to;
}

function polyfill() {
  if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: assign
    });
  }
}

module.exports = {
  assign: assign,
  polyfill: polyfill
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {

  // Store setTimeout reference so promise-polyfill will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var setTimeoutFunc = setTimeout;

  function noop() {}
  
  // Polyfill for Function.prototype.bind
  function bind(fn, thisArg) {
    return function () {
      fn.apply(thisArg, arguments);
    };
  }

  function Promise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];

    doResolve(fn, this);
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }
    if (self._state === 0) {
      self._deferreds.push(deferred);
      return;
    }
    self._handled = true;
    Promise._immediateFn(function () {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }
      var ret;
      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = newValue.then;
        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }
      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function() {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }

  /**
   * Take a potentially misbehaving resolver function and make sure
   * onFulfilled and onRejected are only called once.
   *
   * Makes no guarantees about asynchrony.
   */
  function doResolve(fn, self) {
    var done = false;
    try {
      fn(function (value) {
        if (done) return;
        done = true;
        resolve(self, value);
      }, function (reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      });
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  Promise.prototype['catch'] = function (onRejected) {
    return this.then(null, onRejected);
  };

  Promise.prototype.then = function (onFulfilled, onRejected) {
    var prom = new (this.constructor)(noop);

    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.all = function (arr) {
    var args = Array.prototype.slice.call(arr);

    return new Promise(function (resolve, reject) {
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && (typeof val === 'object' || typeof val === 'function')) {
            var then = val.then;
            if (typeof then === 'function') {
              then.call(val, function (val) {
                res(i, val);
              }, reject);
              return;
            }
          }
          args[i] = val;
          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function (value) {
    if (value && typeof value === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function (resolve) {
      resolve(value);
    });
  };

  Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
      for (var i = 0, len = values.length; i < len; i++) {
        values[i].then(resolve, reject);
      }
    });
  };

  // Use polyfill for setImmediate for performance gains
  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
    function (fn) {
      setTimeoutFunc(fn, 0);
    };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
    }
  };

  /**
   * Set the immediate function to execute callbacks
   * @param fn {function} Function to execute
   * @deprecated
   */
  Promise._setImmediateFn = function _setImmediateFn(fn) {
    Promise._immediateFn = fn;
  };

  /**
   * Change the function to execute on unhandled rejection
   * @param {function} fn Function to execute on unhandled rejection
   * @deprecated
   */
  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
    Promise._unhandledRejectionFn = fn;
  };
  
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Promise;
  } else if (!root.Promise) {
    root.Promise = Promise;
  }

})(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).setImmediate))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(34);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12), __webpack_require__(35)))

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 36 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biLoggerFactory = __webpack_require__(38);

var _biLoggerFactory2 = _interopRequireDefault(_biLoggerFactory);

var _env = __webpack_require__(5);

var _publishers = __webpack_require__(43);

var _browsingSession = __webpack_require__(46);

var browsingSession = _interopRequireWildcard(_browsingSession);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var publisher = void 0;

  if ((0, _env.isWebWorker)()) {
    publisher = _publishers.fetchPublisher;
  } else if (options.useBeacon) {
    publisher = _publishers.beaconPublisher;
  } else {
    publisher = _publishers.imagePublisher;
  }

  return publisher(options);
}

var logger = {
  factory: function factory(options) {
    return new _biLoggerFactory2.default().addPublisher(getPublisher(options));
  },
  setHost: _env.setHost
};

browsingSession.track(logger.factory);

exports.default = logger;
//# sourceMappingURL=logger.js.map


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = __webpack_require__(14);
var BiLogger = __webpack_require__(39);

var BiLoggerFactory = function () {
  function BiLoggerFactory() {
    _classCallCheck(this, BiLoggerFactory);

    this._publishers = [];
    this._validators = [];
    this._defaults = {};
    this._events = {};
  }

  _createClass(BiLoggerFactory, [{
    key: 'addPublisher',
    value: function addPublisher(publisher) {
      assert.defined(publisher, 'Publisher must be provided');
      assert.ok(typeof publisher === 'function', 'Expected a publisher function');
      this._publishers.push(publisher);
      return this;
    }
  }, {
    key: 'addValidator',
    value: function addValidator(validator) {
      assert.defined(validator, 'Validator must be provided');
      assert.ok((typeof validator === 'undefined' ? 'undefined' : _typeof(validator)) === 'object' && validator, 'Expected a validator object');
      assert.ok(validator.execute && validator.match, 'Provided validator does not match the interface');
      this._validators.push(validator);
      return this;
    }
  }, {
    key: 'setDefaults',
    value: function setDefaults(defaults) {
      assert.defined(defaults, 'Defaults must be provided');
      assert.object(defaults, 'Defaults must be an object');
      this._defaults = defaults;
      return this;
    }
  }, {
    key: 'updateDefaults',
    value: function updateDefaults(defaults) {
      assert.defined(defaults, 'Defaults must be provided');
      assert.object(defaults, 'Defaults must be an object');
      Object.assign(this._defaults, defaults);
      return this;
    }
  }, {
    key: 'setEvents',
    value: function setEvents(events) {
      assert.defined(events, 'Events must be provided');
      assert.object(events, 'Events must be an object');
      this._events = events;
      return this;
    }
  }, {
    key: 'setDefaultValueTimeout',
    value: function setDefaultValueTimeout(defaultValueTimeout) {
      assert.defined(defaultValueTimeout, 'Default Value Timeout must be provided');
      this._defaultValueTimeout = defaultValueTimeout;
      return this;
    }
  }, {
    key: 'setDefaultContinueOnFail',
    value: function setDefaultContinueOnFail(defaultContinueOnFail) {
      assert.defined(defaultContinueOnFail, 'Default Continue On Fail must be provided');
      this._defaultContinueOnFail = defaultContinueOnFail;
      return this;
    }
  }, {
    key: 'logger',
    value: function logger(context) {
      return new BiLogger({
        publishers: this._publishers,
        validators: this._validators,
        defaults: this._defaults,
        events: this._events,
        defaultValueTimeout: this._defaultValueTimeout,
        defaultContinueOnFail: this._defaultContinueOnFail
      }, context);
    }
  }]);

  return BiLoggerFactory;
}();

module.exports = BiLoggerFactory;
//# sourceMappingURL=bi-logger-factory.js.map

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = __webpack_require__(14);

var _require = __webpack_require__(40),
    mapValues = _require.mapValues;

var promise = __webpack_require__(41);

var _require2 = __webpack_require__(42),
    log = _require2.log;

var BiLogger = function () {
  //TODO: validate args
  function BiLogger(options, context) {
    _classCallCheck(this, BiLogger);

    this._publishers = options.publishers;
    this._validators = options.validators || [];
    this._defaults = options.defaults;
    this._events = options.events || {};
    this._context = context;
    this._defaultValueTimeout = options.defaultValueTimeout || 5000;
    this._defaultContinueOnFail = options.defaultContinueOnFail || false;
  }

  _createClass(BiLogger, [{
    key: 'log',
    value: function log(eventOrKey, eventOrUndefined) {
      var _this = this;

      assert.defined(eventOrKey, 'Event object or event key must be provided.');
      var event = this._eventOrExtractFromEvents(eventOrKey, eventOrUndefined);

      var validatorsResult = this._validators.length === 0 ? true : this._validators.some(function (validator) {
        return validator.match(event) && (validator.execute(event) || true);
      });

      if (!validatorsResult) {
        throw new Error('No validator accepted the event');
      }

      return this._getDefaults().then(function (defaults) {
        return Promise.all(_this._publishers.map(function (publish) {
          var cloned = Object.assign({}, defaults, event);

          return Promise.resolve().then(function () {
            return publish(cloned, _this._context);
          }).catch(function (error) {
            if (error && error.message && error.stack) {
              error.message = 'Publisher \'' + publish.name + '\' failed with error: \'' + error.message + '\'';
            }

            return Promise.reject(error);
          });
        }));
      });
    }
  }, {
    key: '_eventOrExtractFromEvents',
    value: function _eventOrExtractFromEvents(eventOrKey, eventOrUndefined) {
      if (typeof eventOrKey !== 'string') {
        return eventOrKey;
      }
      var event = this._events[eventOrKey];
      if (!event) {
        throw new assert.AssertionError('Event with key \'' + eventOrKey + '\' not found in event map.');
      }

      if (eventOrUndefined) {
        return Object.assign({}, event, eventOrUndefined);
      } else {
        return event;
      }
    }
  }, {
    key: '_getDefaults',
    value: function _getDefaults() {
      var _this2 = this;

      if (!this._defaults) {
        return Promise.resolve({});
      }

      var promises = mapValues(this._defaults, function (value, key) {
        if (value && typeof value.then !== 'function') {
          return value;
        }
        return promise.timedPromise(value, {
          message: 'Cannot get default value \'' + key + ' for BI Event\'',
          timeout: _this2._defaultValueTimeout
        }).catch(function (err) {
          if (_this2._defaultContinueOnFail) {
            log.error(err);
            return null;
          }
          return Promise.reject(err);
        });
      });

      return promise.allAsObject(promises);
    }
  }]);

  return BiLogger;
}();

module.exports = BiLogger;
//# sourceMappingURL=bi-logger.js.map

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This callback type is called `requestCallback` and is displayed as a global symbol.
 *
 * @callback iterateeCallback
 * @param {*} Value
 * @param {string} Key
 * @param {object} Original object
 */
/**
 * Iterates over object values
 * @param {Object} collection
 * @param {iterateeCallback} iteratee
 * @return {Object} iterated object
 */
module.exports.mapValues = function (collection, iteratee) {
  if (!collection) {
    return {};
  }
  return Object.keys(collection).reduce(function (acc, key) {
    acc[key] = iteratee(collection[key], key, collection);
    return acc;
  }, {});
};
//# sourceMappingURL=collections.js.map

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * rejects original promise after specified timeout
 * @param {Promise<R>} promise Original promise
 * @param {string} [message] Additional message for timeout reject
 * @param {number} timeout Time for reject
 * @return {Promise<R>}
 */
module.exports.timedPromise = function (promise, _ref) {
  var message = _ref.message,
      timeout = _ref.timeout;

  var timeoutPromise = new Promise(function (resolve, reject) {
    setTimeout(reject, timeout, message ? 'Timeout: ' + message : 'Timeout');
  });
  return Promise.race([promise, timeoutPromise]);
};

/**
 * Works like Promise.all expect uses object insetead of array.
 * @param {Object} promiseObject
 * @return {Promise} Promise wiht original keys and resolved values
 */
module.exports.allAsObject = function (promiseObject) {
  var keys = Object.keys(promiseObject);
  return Promise.all(keys.map(function (key) {
    return promiseObject[key];
  })).then(function (resolved) {
    return resolved.reduce(function (acc, value, i) {
      acc[keys[i]] = value;
      return acc;
    }, {});
  });
};
//# sourceMappingURL=promise.js.map

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.log = {
  error: function error() {
    if (console && console.error) {
      var _console;

      (_console = console).error.apply(_console, arguments);
    }
  }
};
//# sourceMappingURL=log.js.map

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPublisher = exports.beaconPublisher = exports.imagePublisher = undefined;

var _utils = __webpack_require__(15);

var _transport = __webpack_require__(45);

function base(publish) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (params) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return publish((0, _utils.buildUrl)(options, params), context);
    };
  };
}

var imagePublisher = exports.imagePublisher = base(function (url, context) {
  return (0, _transport.pixel)(url, context.image);
});

var beaconPublisher = exports.beaconPublisher = base(function (url, context) {
  return (0, _transport.beacon)(url).catch(function () {
    return (0, _transport.pixel)(url, context.image);
  });
});

var fetchPublisher = exports.fetchPublisher = base(function (url) {
  return fetch(url, { credentials: 'include' }).then(function (response) {
    if (!response.ok) {
      throw Error(response.status);
    }
    return response;
  });
});
//# sourceMappingURL=publishers.js.map


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.now = now;
function now() {
  return typeof performance !== 'undefined' && performance && performance.now ? performance.now() : -1;
}
//# sourceMappingURL=performance.js.map


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.beacon = beacon;
exports.pixel = pixel;

var _navigator = __webpack_require__(16);

function beacon(url) {
  return new Promise(function (resolve, reject) {
    return (0, _navigator.sendBeacon)(url) ? resolve(url) : reject(url);
  });
}

function pixel(url, image) {
  return new Promise(function (resolve, reject) {
    var biImage = image || new Image(0, 0);
    biImage.onload = resolve;
    biImage.onerror = reject;
    biImage.src = url;
  });
}
//# sourceMappingURL=transport.js.map


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.track = track;

var _utils = __webpack_require__(15);

var _navigator = __webpack_require__(16);

var _env = __webpack_require__(5);

var IS_TRACKING = '__isTrackingBiBrowsingSession__';
var ENDPOINT = 'p';
var SOURCE = 19;
var EVID = 3;

function shouldTrack() {
  return !(0, _env.isWebWorker)() && (0, _env.provideBrowsingContext)(function (window) {
    return !window[IS_TRACKING];
  });
}

function setIsTracking() {
  return (0, _env.provideBrowsingContext)(function (window) {
    return window[IS_TRACKING] = true;
  });
}

function getLogger(loggerFactory) {
  return loggerFactory({ endpoint: ENDPOINT, useBeacon: true }).setDefaults({ src: SOURCE, evid: EVID, vsi: (0, _utils.guid)() }).logger();
}

/**
 * Sends a page view event on initial load and on every page switch
 */
function track(loggerFactory) {
  if (shouldTrack()) {
    setIsTracking();

    var logger = getLogger(loggerFactory);
    (0, _navigator.listen)(function (fromUrl, toUrl) {
      return logger.log({ from: fromUrl, to: toUrl });
    });
  }
}
//# sourceMappingURL=browsingSession.js.map


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = {"baseUrl":"https://static.parastorage.com/services/marketing-header-and-footer/1.53.0/"}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (nodes, config, translations, user) {
  var isMobile = (0, _config.useMobileVersion)(config);
  var context = { map: map, translations: translations, isMobile: isMobile, config: config, user: user };

  ['header', 'footer'].forEach(function (part) {
    var cssModule = css['css' + (0, _utils.capitalize)(part) + (0, _utils.capitalize)(isMobile ? 'mobile' : 'desktop')];
    if (config.hostPage && cssModule[config.hostPage]) {
      (0, _utils.toggleClass)(document.body, cssModule[config.hostPage], true);
    }
    (0, _utils.innerHTML)(nodes[part], { header: _header2.default, footer: _footer2.default }[part](context), cssModule.container, config.language);
  });

  if (isMobile) {
    headerMobileUtils.markCurrentMenuItem();
    headerMobileUtils.bindStateChangeListener();
    headerMobileUtils.bindLinkClicks();
    headerMobileUtils.preventSafariBackButtonCache();
  } else {
    headerDesktopUtils.markCurrentMenuItem();
  }
};

var _map = __webpack_require__(49);

var map = _interopRequireWildcard(_map);

var _utils = __webpack_require__(0);

var _config = __webpack_require__(17);

var _header = __webpack_require__(50);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(52);

var _footer2 = _interopRequireDefault(_footer);

var _mobileUtils = __webpack_require__(6);

var headerMobileUtils = _interopRequireWildcard(_mobileUtils);

var _desktopUtils = __webpack_require__(11);

var headerDesktopUtils = _interopRequireWildcard(_desktopUtils);

var _mobile = __webpack_require__(3);

var _mobile2 = _interopRequireDefault(_mobile);

var _mobile3 = __webpack_require__(7);

var _mobile4 = _interopRequireDefault(_mobile3);

var _desktop = __webpack_require__(4);

var _desktop2 = _interopRequireDefault(_desktop);

var _desktop3 = __webpack_require__(8);

var _desktop4 = _interopRequireDefault(_desktop3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var css = { cssHeaderMobile: _mobile2.default, cssFooterMobile: _mobile4.default, cssHeaderDesktop: _desktop2.default, cssFooterDesktop: _desktop4.default };

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = {"header.nav.1":"sub_menu_features | /features/main","header.nav.2":"menu_explore | /explore/website","header.nav.3":"menu_subscriptions | /upgrade/website","header.nav.3.1":"sub_menu_upgrade_plans | /upgrade/website","header.nav.3.2":"footer_domains | /domain/names","header.nav.3.3":"sub_menu_mailboxes | /about/mailboxes","header.nav.4":"sub_menu_templates | /website/templates","header.nav.5":"menu_support | https://support.wix.com/en","header.userNav.1":"menu_account_settings | /my-account/settings","header.userNav.2":"menu_billing_and_payments | https://premium.wix.com/wix/api/PaymentConsole","header.userNav.3":"menu_vouchers | https://premium.wix.com/wix/api/voucherConsole","footer.nav.1":"footer_product","footer.nav.1.1":"menu_templates | /website/templates","footer.nav.1.2":"menu_explore | /explore/websites","footer.nav.1.3":"sub_menu_features | /features/main","footer.nav.1.4":"sub_menu_wixcode | /code/home","footer.nav.1.5":"menu_my_account | /my-account","footer.nav.1.6":"sub_menu_upgrade_plans | /upgrade/website","footer.nav.1.7":"footer_seo | /about/seo","footer.nav.1.8":"footer_ecommerce | /ecommerce/website","footer.nav.1.9":"footer_app_market | /app-market/main","footer.nav.1.10":"footer_domains | /domain/names","footer.nav.1.11":"footer_developers | //dev.wix.com","footer.nav.1.12":"footer_shoutout | /shoutout/email-marketing","footer.nav.2":"footer_company","footer.nav.2.1":"footer_about_wix | /about/us","footer.nav.2.2":"footer_investor_relations | http://investors.wix.com","footer.nav.2.3":"footer_jobs | /jobs/home","footer.nav.2.4":"footer_design_assets | /about/design-assets","footer.nav.2.5":"footer_terms_of_use | /about/terms-of-use","footer.nav.2.6":"footer_app_market_terms | /about/app-market-terms","footer.nav.2.7":"footer_privacy | /about/privacy","footer.nav.2.8":"footer_abuse | /upgrade/abuse","footer.nav.2.9":"footer_affiliates | /about/affiliates","footer.nav.2.10":"footer_update_and_release | /release/notes","footer.nav.2.11":"footer_contact_us | /about/contact-us","footer.nav.3":"footer_community","footer.nav.3.1":"footer_wix_blog | /blog","footer.nav.3.2":"footer_wix_stories | /stories","footer.nav.3.3":"footer_wix_arena | /arena","footer.nav.3.4":"footer_wix_lounge | /lounge/main","footer.nav.3.5":"footer_wix_ontheroad | http://www.wixontheroad.com/","footer.nav.3.6":"Facebook | https://www.facebook.com/wix","footer.nav.3.7":"Twitter | https://twitter.com/wix","footer.nav.3.8":"Google+ | https://plus.google.com/+Wix/posts","footer.nav.3.9":"Pinterest | http://www.pinterest.com/wixcom","footer.nav.3.10":"Youtube | http://www.youtube.com/user/Wix","footer.nav.3.11":"Linkedin | https://www.linkedin.com/company/wix-com?trk=biz-companies-cym","footer.nav.3.12":"Instagram | https://www.instagram.com/wix/","footer.nav.4":"menu_support","footer.nav.4.1":"footer_support_center | //support.wix.com/en","header.mobileNav.1":"menu_home | /","header.mobileNav.2":"sub_menu_features | /features/main","header.mobileNav.3":"menu_explore | /explore/website","header.mobileNav.4":"sub_menu_templates | /website/templates","header.mobileNav.5":"sub_menu_upgrade_plans | /upgrade/website |  |  |  | important","header.mobileNav.6":"footer_wix_blog | /blog |  |  |  | important","header.mobileNav.7":"menu_support | //support.wix.com/en |  |  |  | important","footer.mobileNav.1":"sub_menu_domains | /domain/names","footer.mobileNav.2":"footer_ecommerce | /ecommerce/website","footer.mobileNav.3":"footer_about_wix | /about/us","footer.mobileNav.4":"footer_wix_stories | /stories","footer.mobileNav.5":"footer_jobs | /jobs/home","footer.mobileNav.6":"footer_wix_blog | /blog","footer.mobileNav.7":"footer_terms_of_use | /about/terms-of-use","footer.mobileNav.8":"footer_privacy | /about/privacy"}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    getValueFromObjectByPrefix = _require.getValueFromObjectByPrefix,
    menuFromMap = _require.menuFromMap,
    languagesMenu = _require.languagesMenu;

var _require2 = __webpack_require__(1),
    domains = _require2.domains,
    languages = _require2.languages;

var cssMobile = __webpack_require__(3);
var cssDesktop = __webpack_require__(4);

var _require3 = __webpack_require__(2),
    modifyBlogLink = _require3.modifyBlogLink;

module.exports = function (_ref) {
  var map = _ref.map,
      translations = _ref.translations,
      isMobile = _ref.isMobile,
      user = _ref.user,
      config = _ref.config;

  var t = getValueFromObjectByPrefix(translations);

  var mainLinks = menuFromMap(map, isMobile ? 'header.mobileNav' : 'header.nav', translations, config.language, [modifyBlogLink]);

  var userLinks = menuFromMap(map, 'header.userNav', translations, config.language);

  if (user && !isMobile) {
    mainLinks.unshift({
      href: '//' + domains.wix + '/my-account',
      text: t('menu_my_account')
    });
  }

  if (isMobile) {
    var contentAttrs = {};
    contentAttrs.for = cssMobile.languagesOpen;
    mainLinks.push({
      text: '<i class="' + cssMobile.icon + ' ' + cssMobile.iconGlobe + '"></i>' + languages[config.language] + '<i class="' + cssMobile.icon + ' ' + cssMobile.iconArrowRight + ' ' + cssMobile.iconToRight + '"></i>',
      tag: 'label',
      classes: user ? cssMobile.divider : null,
      contentAttrs: contentAttrs
    });
    mainLinks.forEach(function (link) {
      if (link.important) {
        link.classes = cssMobile.important;
      }
    });

    if (user) {
      mainLinks.push({
        href: '//' + domains.wix + '/signout',
        text: '<i class="' + cssMobile.icon + ' ' + cssMobile.iconLogout + '"></i>' + t('logout')
      });
    }
  }

  userLinks.push({
    tag: 'button',
    text: languages[config.language],
    subs: languagesMenu(config.supportedLanguages),
    attrs: { rel: 'languages' },
    extraContent: '<i class="' + cssDesktop.icon + ' ' + cssDesktop.iconGlobe + '"></i>'
  });

  userLinks.push({
    href: '//' + domains.wix + '/signout',
    text: t('logout')
  });

  return __webpack_require__(51)("./" + (isMobile ? 'mobile' : 'desktop'))({ mainLinks: mainLinks, userLinks: userLinks, user: user, t: t, config: config });
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./desktop": 18,
	"./desktop.js": 18,
	"./desktop.scss": 4,
	"./desktopUtils": 11,
	"./desktopUtils.js": 11,
	"./mobile": 19,
	"./mobile.js": 19,
	"./mobile.scss": 3,
	"./mobileUtils": 6,
	"./mobileUtils.js": 6
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = __webpack_require__(0),
    getValueFromObjectByPrefix = _require.getValueFromObjectByPrefix,
    menuFromMap = _require.menuFromMap,
    toCamelCase = _require.toCamelCase,
    arrayWithoutDublicates = _require.arrayWithoutDublicates;

var cssMobile = __webpack_require__(7);
var cssDesktop = __webpack_require__(8);

var _require2 = __webpack_require__(2),
    modifyBlogLink = _require2.modifyBlogLink,
    modifyStoriesLink = _require2.modifyStoriesLink;

var _require3 = __webpack_require__(1),
    socialNetworks = _require3.socialNetworks;

var icons = arrayWithoutDublicates([].concat(socialNetworks.mobile, socialNetworks.desktop)).reduce(function (object, name) {
  return Object.assign(object, _defineProperty({}, name, __webpack_require__(53)("./" + name).default));
}, {});

function getSocialLinks(t, tLinks, isMobile) {
  var css = isMobile ? cssMobile : cssDesktop;
  return socialNetworks[isMobile ? 'mobile' : 'desktop'].map(function (network) {
    return {
      text: icons[network],
      href: tLinks(network),
      classes: css.icon + ' ' + css[toCamelCase('icon-' + network)],
      contentAttrs: { target: '_blank' }
    };
  });
}

module.exports = function (_ref) {
  var map = _ref.map,
      translations = _ref.translations,
      isMobile = _ref.isMobile,
      config = _ref.config;

  var t = getValueFromObjectByPrefix(translations, 'footer_');
  var tLinks = getValueFromObjectByPrefix(translations, 'link_');
  var socialLinks = getSocialLinks(t, tLinks, isMobile);
  var mainLinks = menuFromMap(map, 'footer.' + (isMobile ? 'mobileNav' : 'nav'), translations, config.language, [modifyBlogLink, modifyStoriesLink]);

  return __webpack_require__(54)("./" + (isMobile ? 'mobile' : 'desktop'))({ mainLinks: mainLinks, socialLinks: socialLinks, t: t, config: config });
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arrowDown": 10,
	"./arrowDown.js": 10,
	"./facebook": 20,
	"./facebook.js": 20,
	"./globe": 9,
	"./globe.js": 9,
	"./googleplus": 21,
	"./googleplus.js": 21,
	"./instagram": 22,
	"./instagram.js": 22,
	"./linkedin": 23,
	"./linkedin.js": 23,
	"./pinterest": 24,
	"./pinterest.js": 24,
	"./twitter": 25,
	"./twitter.js": 25,
	"./youtube": 26,
	"./youtube.js": 26
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./desktop": 27,
	"./desktop.js": 27,
	"./desktop.scss": 8,
	"./mobile": 28,
	"./mobile.js": 28,
	"./mobile.scss": 7
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.bundle.min.js